import FixtureService from '../../services/FixturesService';
import { PRIVATE_EVENTS, PUBLIC_EVENTS, EVENT_CALLBACK } from '../../handlers/EventManager/constants';
import { ASSETS_IMAGES_BASE_URL } from '../../constants/AssetConstants';
import './index.scss';
import { JSON_IMAGE_BASE_URL } from '../../constants/FixtureConstants';

class FixtureWidget {
  constructor(sportsManager, fixtureConfig) {
    this.fixtureConfig = fixtureConfig;
    this.assetConfig = this.fixtureConfig.assetConfig
    this.jsonConfig = this.fixtureConfig.jsonManagerConfig
    this.sportsManager = sportsManager;
    if (!this.sportsManager) {
      throw new Error('Sports manager is required in Fixtures view.');
    }

    this.eventManager = this.sportsManager.eventManager;
    if (!this.eventManager) {
      throw new Error('Event manager is required in Fixtures view.');
    }

    this.parentDom = document.getElementById(this.assetConfig.parentId);
    if (!this.parentDom) {
      this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS?.SPORTS_MANAGER_ERROR, {
        errorCode: 'err_100',
        errorMessage: 'DOM element is required in fixtures view.',
      });
    }

    this.fixtureData = null;
    this.FEData = this.assetConfig.FEData;
    this.handleCTAClick = this.assetConfig.handleCtaClick;
    this.handleViewAllCard = this.assetConfig.handleViewAllCard;
    this.reminderIds = this.assetConfig.reminderIds;
    this.sportId = this.assetConfig.sportId;
    this.tourId = this.assetConfig.tourId;
    this.widgetCallback = this.assetConfig.widgetCallback

    if (!this.sportId || !this.tourId) {
      this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS?.SPORTS_MANAGER_ERROR, {
        errorCode: 'err_100',
        errorMessage: 'Sports id and tournament is required in fixtures view.',
      });
    }

    this.fixtureStatus = this.assetConfig.status;
    this.completedMatchLength = 0;
    this.liveMatchLength = 0;
    this.upcomingMatchLength = 0;
    this.subscribeToEvents();
  }

  subscribeToEvents() {
    this.eventManager.subscribeToEvents({
      eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
      eventCallback: this.privateEventCallback.bind(this),
      senderName: 'FIXTURE_SERVICE',
    });
  }

  fixtureDataOrdering() {
    let completedMatch = []
    let upcomingMatch = []
    let liveMatch = []
    this.fixtureData.map((match) => {
      if(match?.is_live == true) {
        liveMatch.push(match)
      } else if (match?.is_complete == true) {
        completedMatch.push(match)
      } else if (match?.is_upcoming == true) {
        upcomingMatch.push(match)
      }
    });
    if(liveMatch.length > 0 || upcomingMatch?.length > 0) {
      completedMatch = completedMatch.reverse()
    }
    this.fixtureData = [...completedMatch, ...liveMatch, ...upcomingMatch]
    this.completedMatchLength = completedMatch?.length
    this.liveMatchLength = liveMatch?.length
    this.upcomingMatchLength = upcomingMatch?.length
  }

  privateEventCallback(eventName, eventData) {
    switch (eventName) {
      case PRIVATE_EVENTS.FIXTURE_UPDATE: {
        this.fixtureData = eventData?.fixtureWidgetData;
        this.tourMetaData = eventData?.tourMetaData;
        this.fixtureDataOrdering();
        this.render();
        break;
      }

      // default: {
      //   console.log('Uncaught event');
      //   break;
      // }
    }
  }

  getFixtureData() {
    const fixtureService = new FixtureService(this.sportsManager);
    fixtureService.fetchFixtureData(this.sportId, this.tourId, this.fixtureStatus, 0, PRIVATE_EVENTS.FIXTURE_UPDATE,this.jsonConfig);
  }

  destroyFixtureSDK() {
    if(this.parentDom) {
      this.parentDom.innerHTML = "";
      this.eventManager.broadcastPrivateEvent(PRIVATE_EVENTS.FIXTURE_WIDGET_DESTROY);
    }
  }

  renderCard(match,index) {
    const fixtureCard = document.createElement('a');
    fixtureCard.setAttribute('class', 'fixture-card');
    this.handleCTAClick("SET_HREF", match?.match_metadata, (route, isHrefEnabled) => {
      fixtureCard.href = route
      if(isHrefEnabled === false) {
        fixtureCard.classList.add("disablePointer")
      }
    });
    if(this.completedMatchLength > 0 && index == this.completedMatchLength-1 && (this.liveMatchLength > 0 || this.upcomingMatchLength > 0)) {
      fixtureCard.classList.add("scrollToview")
    }

    const titleFixtureCard = document.createElement('div');
    titleFixtureCard.setAttribute('class', 'fixture-title-card');

    const matchName = document.createElement('a');
    matchName.innerText = match.series_short_name;
    matchName.setAttribute('class', 'fixture-match-name');
    this.handleCTAClick("SET_HREF", this.tourMetaData, (route, isHrefEnabled) => {
      matchName.href = route
      if(isHrefEnabled === false) {
        matchName.classList.add("disablePointer")
      }
    });

    titleFixtureCard.appendChild(matchName);

    fixtureCard.appendChild(titleFixtureCard);

    const fixtureMatchStatus = document.createElement('div');
    fixtureMatchStatus.setAttribute('class', 'fixture-match-status');
    fixtureMatchStatus.innerText = match?.matchStage;
    fixtureCard.appendChild(fixtureMatchStatus);

    const teamDetails = document.createElement('div');
    teamDetails.setAttribute('class', 'fixture-team-details');
    fixtureCard.appendChild(teamDetails);

    const fixtureHomeTeam = document.createElement('div');
    fixtureHomeTeam.setAttribute('class', 'fixture-home-team');
    teamDetails.appendChild(fixtureHomeTeam);

    let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL;
    const homeLogoSrc = `${imageEndPoint}/${this.sportId}/${match.teama_id}.png`

    const homeDetails = this.renderTeamDetails('home', match.teama_short, match.teama_score, homeLogoSrc, match);
    fixtureHomeTeam.appendChild(homeDetails);

    const scoreDetails = document.createElement('div');
    scoreDetails.setAttribute('class', 'fixture-detail-cont');
    teamDetails.appendChild(scoreDetails);

    const matchDate = document.createElement('div');
    matchDate.setAttribute('class', 'fixture-match-date');
    const dateFormat = new Date(match.matchDate).toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });

    matchDate.innerText = `${dateFormat}`;
    scoreDetails.appendChild(matchDate);

    const teamHomeScore = document.createElement('div');
    teamHomeScore.setAttribute('class', 'fixture-home-score');
    teamHomeScore.innerText =
      match.teama_score && match.teamb_score
        ? `${match.teama_score} : ${match.teamb_score}`
        : `${match.matchtime_local}`;
    scoreDetails.appendChild(teamHomeScore);

    const fixtureAwayTeam = document.createElement('div');
    fixtureAwayTeam.setAttribute('class', 'fixture-away-team');
    teamDetails.appendChild(fixtureAwayTeam);

    const awayLogoSrc = `${imageEndPoint}/${this.sportId}/${match.teamb_id}.png`

    const awayDetails = this.renderTeamDetails('away', match.teamb_short, match.teamb_score, awayLogoSrc, match);
    fixtureAwayTeam.appendChild(awayDetails);

    let reminderIds = typeof localStorage != "undefined" && localStorage.getItem("sports_reminders") ? JSON.parse(localStorage.getItem("sports_reminders")) : this.reminderIds;
    let reminderAddId = typeof localStorage != "undefined" && localStorage.getItem("reminderMatchTourId") ?  localStorage.getItem("reminderMatchTourId") : "";
    if(reminderAddId && !reminderIds.includes(reminderAddId)) {
      reminderIds.push(reminderAddId)
    }
    let isSetReminder = reminderIds?.filter((item) => {
      return item.includes(match.match_id);
    });

    if(match.teama_score && match.teamb_score && match?.is_complete == true) {
      const scoreTextCont = document.createElement('div');
      scoreTextCont.setAttribute('class', 'fixture-score-text-concluded');
      scoreTextCont.innerText = match?.matchStatus;
      scoreDetails.appendChild(scoreTextCont);
    }

    if(match.teama_score && match.teamb_score && match?.is_live == true && match?.minutes) {
      const fixtureMinuteCont = document.createElement('div');
      fixtureMinuteCont.setAttribute('class', 'fixture-minutes-conatiner');
      let additinalMinutes = "";
      if (match?.additional_minutes > 0) {
          additinalMinutes = `+${match.additional_minutes}'`;
      }
      fixtureMinuteCont.innerText = `${match?.minutes}'${additinalMinutes}`;
      scoreDetails.appendChild(fixtureMinuteCont);
    }

    if (match?.metaDatum?.objectSubtype == "HIGHLIGHTS" && match?.metaDatum?.contentId != 0) {
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
      fixtureButtonContainer.href = "javascript:void(0);";
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.textContent = 'Watch Highlights';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_HIGHLIGHTS_EVENTS', match);
      });
      fixtureCard.appendChild(fixtureButtonContainer);
    } else if (!match?.metaDatum?.objectSubtype && match?.match_status_id == "9" && (match?.match_id!= 0 || match?.metaDatum?.contentId != 0) && match?.releaseStartDate != 0 && match?.releaseStartDate > Date.now()) {
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-yet-begin');
      fixtureButtonContainer.href = "javascript:void(0);";
      const logoImg = new Image();
      logoImg.src = `${ASSETS_IMAGES_BASE_URL}/Notification.svg`;
      fixtureButtonContainer.appendChild(logoImg);
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.textContent = 'Set Reminder';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      if(isSetReminder?.length > 0) {
        fixtureButtonContainer.classList.add("disabled")
        logoImg.src = `${ASSETS_IMAGES_BASE_URL}/Tick.svg`;;
        fixtureButtonText.innerHTML = "Reminder Set";
      }
      fixtureButtonContainer.addEventListener("click",(e) => {
        if(!e.currentTarget.classList.contains("disabled")) {
          e.stopPropagation();
          this.handleCTAClick("SET_REMINDER_EVENTS",match,(setReminderStatus) => {
            if(setReminderStatus == true) {
              fixtureButtonContainer.classList.add("disabled")
              logoImg.src = `${ASSETS_IMAGES_BASE_URL}/Tick.svg`;;
              fixtureButtonText.innerHTML = "Reminder Set";
            }
          });
        }
      });
      fixtureCard.appendChild(fixtureButtonContainer);
    } else if (match?.metaDatum?.objectSubtype == "LIVE_SPORT" && match?.metaDatum?.contentId != 0) {
      const fixtureButtonContainer = document.createElement('a');
      fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-live');
      fixtureButtonContainer.href = "javascript:void(0);";
      const fixtureButtonText = document.createElement('div');
      fixtureButtonText.setAttribute('class', 'fixture-button-text');
      fixtureButtonText.textContent = 'Watch Live';
      fixtureButtonContainer.appendChild(fixtureButtonText);
      if(match?.metaDatum?.contractStartDate != 0 && match?.metaDatum?.contractStartDate > Date.now()){
        fixtureButtonContainer.style.display = 'none'
        let delta = match?.metaDatum?.contractStartDate - Date.now()
        setTimeout(()=> {
            fixtureButtonContainer.style.display = 'flex'
        },delta)
      }
      fixtureButtonContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCTAClick('WATCH_LIVE_EVENTS', match);
      });
      fixtureCard.appendChild(fixtureButtonContainer);
    }

    if(typeof localStorage != "undefined" && localStorage.getItem("FIXTURE_CLICK_ENABLED") == 'true') {
      fixtureCard.addEventListener("click",(e) => {
        e.preventDefault();
        this.handleCTAClick("FIXTURE_CARD_CLICK", match);
      });
    }
    
    // document.getElementsByClassName('fixture-container-slides')[0].appendChild(fixtureCard);
    this.wrapperSlides.appendChild(fixtureCard);
  }

  renderTeamDetails(teamType, teamName, teamRun, image, match) {
    const logoImg = new Image();
    logoImg.src = image;
    logoImg.onerror = function (e) {
      logoImg.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
    }
    logoImg.alt = teamName;
    const classList = `team-info-wrapper team-info-wrapper--${teamType}`;
    let wrapper = document.createElement('a');
    wrapper.setAttribute('class', classList);
    let teamMetaData = match?.teama_metadata;
    if(teamType === "away") {
        teamMetaData = match?.teamb_metadata;
    }
    this.handleCTAClick("SET_HREF", teamMetaData, (route, isHrefEnabled) => {
        wrapper.href = route
        if(isHrefEnabled === false) {
          wrapper.classList.add("disablePointer")
        }        
    });
    const teamLabel = document.createElement('div');
    teamLabel.setAttribute('class', 'team-name-label');
    teamLabel.innerText = teamName;
    wrapper.appendChild(logoImg);
    wrapper.appendChild(teamLabel);
    return wrapper;
  }

  render() {
    if (this.parentDom && this.fixtureData.length > 0) {
      const numberOfCards = this.FEData?.metadata?.number_ofcard_displayed || 10;
      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'fixture-container');
      this.parentDom.appendChild(wrapper);
      const leftArrowCont = document.createElement('div');
      leftArrowCont.setAttribute('id', 'fixture-prev-arrow');
      wrapper.appendChild(leftArrowCont);
      this.wrapperSlides = document.createElement('div');
      this.wrapperSlides.setAttribute('class', 'fixture-container-slides');
      wrapper.appendChild(this.wrapperSlides);
      this.fixtureData.slice(0, numberOfCards).map((match,index) => {
        this.renderCard(match,index);
      });
      const fixtureCardViewCont = document.createElement('div');
      fixtureCardViewCont.setAttribute('class', 'fixture-card fixture-card-view-cont');
      const fixtureVeiwAllLabel = document.createElement('div');
      fixtureVeiwAllLabel.setAttribute('class', 'fixture-card-view-all');
      fixtureVeiwAllLabel.innerText = 'View More';
      fixtureCardViewCont.appendChild(fixtureVeiwAllLabel);
      fixtureCardViewCont?.addEventListener('click', () => { this.handleViewAllCard(this.tourMetaData) } );
      if(document.getElementsByClassName('fixture-container-slides').length >  0) {
        // document.getElementsByClassName('fixture-container-slides')[0].appendChild(fixtureCardViewCont);
        this.wrapperSlides.appendChild(fixtureCardViewCont);
      }
      const rigthArrowCont = document.createElement('div');
      rigthArrowCont.setAttribute('id', 'fixture-next-arrow');
      wrapper.appendChild(rigthArrowCont);

      rigthArrowCont.addEventListener('click', () => {
        this.wrapperSlides.scrollLeft += this.wrapperSlides.clientWidth / 1.5;
      });

      leftArrowCont.addEventListener('click', () => {
        this.wrapperSlides.scrollLeft -= this.wrapperSlides.clientWidth / 1.5;
      });

      this.wrapperSlides.onscroll = (event) => {
        this.toggleArrows(this.wrapperSlides, rigthArrowCont, leftArrowCont);
      };

      this.widgetCallback("FIXTURE_RENDER_SUCCESS",this.tourMetaData)
      let element = this.wrapperSlides.getElementsByClassName("scrollToview")[0];
      if(element) {
        this.wrapperSlides.scroll({ 
          left: element.offsetLeft / 1.25, 
          behavior: "smooth" 
        });
      }
      this.toggleArrows(this.wrapperSlides, rigthArrowCont, leftArrowCont);

    }
  }

  toggleArrows(container, rigthArrowCont, leftArrowCont) {
    if (container.scrollLeft === 0) {
      leftArrowCont.style.display = 'none';
      container.style.marginLeft ='4.3924vw';
    } else {
      leftArrowCont.style.display = 'block';
      container.style.marginLeft = 0;
    } 

    if (container.scrollLeft + container.clientWidth === container.scrollWidth) {
      rigthArrowCont.style.display = 'none';
    } else {
      rigthArrowCont.style.display = 'block';
      if (container.scrollLeft > 0) {
        leftArrowCont.style.display = 'block';
      }
    }
  }
}

export default FixtureWidget;
